import { CardData } from '../../api/types/DocumentTypes';
import divvyLogo from '../../../assets/imgs/divvy-logo.png';
import rampLogo from '../../../assets/imgs/ramp-logo.webp';
import payrollIcon from '../../../assets/imgs/payroll.jpeg';
import aiIcon from '../../../assets/imgs/ai.jpg';
import bqIcon from '../../../assets/imgs/google-bigquery-logo-1.png';

// These represent the selection cards on the Landing Page from which a user selects what kind of job they'd like to initiate.
// eslint-disable-next-line import/prefer-default-export
export const getAssociationDocuments = (userRoles: string[], isAdmin: boolean): CardData[] => ([
  {
    alt: 'Single Utility Bill Logo',
    category: 'custom',
    description: 'Upload your single utility invoices to be processed into Entrata',
    img: aiIcon,
    metadata: {
      allowedFileTypes: [
        'application/pdf',
        '.pdf',
      ],
      location: 'single-utility-invoice',
    },
    status: '',
    title: 'Single Utility Bills',
    route: '/upload',
    showCard: () => true,
  },
  {
    alt: 'Summary Utility Bill Logo',
    category: 'custom',
    description: 'Upload your summary utility invoices to be processed into Entrata',
    img: aiIcon,
    metadata: {
      allowedFileTypes: [
        'application/pdf',
        '.pdf',
      ],
      location: 'summary-utility-invoice',
    },
    status: '',
    title: 'Summary Utility Bills',
    route: '/upload',
    showCard: () => true,
  },
  {
    alt: 'Vendor Statements Logo',
    category: 'Statements',
    description: 'Upload Vendor Statements to BigQuery',
    img: bqIcon,
    metadata: {
      allowedFileTypes: [],
      location: 'vendor-statement',
    },
    status: '',
    title: 'Vendor Statements',
    route: '/vendor-statements',
    showCard: () => isAdmin || userRoles.includes('vendor-statements'),
  },
  {
    alt: 'Divvy Logo',
    category: 'transactions',
    description: 'Upload Divvy invoices to Entrata',
    img: divvyLogo,
    metadata: {
      allowedFileTypes: [],
      location: 'divvy-invoice',
    },
    status: '',
    title: 'Divvy Invoices',
    route: '/divvy-transactions',
    showCard: () => true,
  },
  {
    alt: 'Ramp Logo',
    category: 'transactions',
    description: 'Upload Ramp invoices to Entrata',
    img: rampLogo,
    metadata: {
      allowedFileTypes: [],
      location: 'ramp-invoice',
    },
    status: '',
    title: 'Ramp Invoices',
    route: '/ramp-transactions',
    showCard: () => true,
  },
  {
    alt: 'Payroll Logo',
    category: 'scheduled',
    description: 'Configure and review automatic payroll invoices uploader',
    img: payrollIcon,
    metadata: {
      allowedFileTypes: [],
      location: 'payroll-invoice',
    },
    status: '',
    title: 'Payroll Invoices',
    route: '/payroll-invoice',
    showCard: () => isAdmin,
  },
]).filter((doc) => doc.showCard());
